// extracted by mini-css-extract-plugin
export default {"container":"NftLeftInfo_container__n1hs3","links":"NftLeftInfo_links__wL4dA"};